/* eslint-disable import/no-anonymous-default-export */
import Map from "@mui/icons-material/Map";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import PermIdentityRoundedIcon from '@mui/icons-material/PermIdentityRounded';
export default [
  // {
  //   name: "مسیرها",
  //   path: "/paths",
  //   icon: Map,
  // },
  // {
  //   name: "سفارشات",
  //   path: "/tickets/enable",
  //   icon: LocalActivityIcon,
  // },
  {
    name: "سوپر‌اپ",
    path: "/app",
    icon: PhoneIphoneRoundedIcon,
  },
  {
    name: "دربستی",
    path: "/hiring",
    icon: LocalTaxiIcon,
  },
  {
    name: "آدرس‌های من",
    path: "/addresses",
    icon: StarOutlineRoundedIcon,
  },
  {
    name: "پروفایل",
    path: "/profile",
    icon: PermIdentityRoundedIcon,
  },
];
